(function () {
  // Short-circuit empty-product requests (e.g. /products/.js) to avoid noisy 404s
  // when a featured-product or similar section attempts to fetch a product with
  // an empty handle. This runs very early (before other scripts) and only affects
  // same-origin requests that match the empty-product pattern. It returns a
  // minimal JSON object so downstream code that expects JSON won't error.
  function isEmptyProductUrl(url) {
    try {
      var u = new URL(url, location.href);
      if (u.origin !== location.origin) return false;
      // Match paths like /products/.js or /products/.js?<query>
      return /\/products\/\.js(?:$|[?#])/.test(u.pathname + (u.search || ""));
    } catch (e) {
      return false;
    }
  }

  // Patch fetch
  if (window.fetch) {
    var _fetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url;
      if (isEmptyProductUrl(url)) {
        return Promise.resolve(
          new Response("{}", {
            status: 200,
            headers: { "Content-Type": "application/json" },
          })
        );
      }
      return _fetch(input, init);
    };
  }

  // Patch XHR open/send to short-circuit the empty-product call
  try {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__requestedUrl = url;
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      try {
        if (isEmptyProductUrl(this.__requestedUrl)) {
          // emulate a successful JSON response asynchronously
          var self = this;
          setTimeout(function () {
            try {
              self.readyState = 4;
              self.status = 200;
              Object.defineProperty(self, "responseText", {
                value: "{}",
                configurable: true,
              });
              if (typeof self.onreadystatechange === "function")
                self.onreadystatechange();
              if (typeof self.onload === "function") self.onload();
            } catch (e) {}
          }, 0);
          return;
        }
      } catch (e) {}
      return _send.apply(this, arguments);
    };
  } catch (e) {}
})();
